import { useState } from "react";
import { copyText } from "../lib/format.ts";
import { UNKNOWN_FACT } from "@shared/labels.ts";

export function FactRow({
  label,
  value,
  copyable,
  quiet,
}: {
  label: string;
  value?: string | null;
  copyable?: boolean;
  quiet?: boolean;
}) {
  const [copyState, setCopyState] = useState<"copied" | "denied" | null>(null);
  const missing = !value;
  return (
    <div className={`fact-row ${quiet || missing ? "quiet" : ""}`}>
      <div>
        <dt>{label}</dt>
        <dd className={missing ? "soft" : undefined}>{value ?? UNKNOWN_FACT}</dd>
        {copyState === "copied" ? <p className="muted">Copied.</p> : null}
        {copyState === "denied" ? <p className="muted">Clipboard blocked on this device.</p> : null}
      </div>
      {value && copyable ? (
        <button
          className="btn-ghost"
          type="button"
          onClick={() => void copyText(value).then(setCopyState)}
        >
          Copy
        </button>
      ) : null}
    </div>
  );
}
